import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VansDevicesComponent } from './vans-devices/vans-devices.component';
import { VansRoutesComponent } from './vans-routes/vans-routes.component';
import { ChecklistVanComponent } from './checklist-van/checklist-van.component';

const routes: Routes = [
  {
    path: 'vansdevices',
    component: VansDevicesComponent,
  },
  {
    path: 'vansroutes',
    component: VansRoutesComponent,
  },
  {
    path: 'checklistvans',
    component: ChecklistVanComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VanTransferRoutingModule {}
